(function () {
  var BH = 'https://cdn.shopify.com/s/files/1/0688/6758/8396/files';
  var AUDIO = {
    dual:    BH + '/dual-series.MP3?v=1778186377',
    quad:    BH + '/quad-sound.MP3?v=1778185128',
    extreme: BH + '/extreme-series.MP3?v=1778184447',
    boss:    BH + '/boss-series.MP3?v=1778184108'
  };

  // spec format: [['Label','Value'], ...]  rendered KEY  →  VALUE
  var TIERS = [
    { match: /boss\s*series/i,            db: '150 dB+',     isNew: true,  audio: AUDIO.boss,
      specs: [['Loudness', '150 dB+'], ['Audible to', '1+ mile'], ['Tone', 'Deep']] },
    { match: /extreme\s+(series|quad)/i,  db: '150 dB',      isNew: false, audio: AUDIO.extreme,
      specs: [['Loudness', '150 dB'], ['Audible to', '~1 mile'], ['Tone', 'Deep']] },
    { match: /extreme\s+trumpets/i,       db: '+40%',        isNew: false, audio: AUDIO.extreme,
      specs: [['Loudness', '+40% boost'], ['Audible to', '~1 mile'], ['Tone', 'Low']] },
    { match: /(2026 model|new 2026)/i,    db: '130 dB',      isNew: true,  audio: AUDIO.dual,
      specs: [['Loudness', '130 dB'], ['Audible to', '~1/4 mile'], ['Tone', 'Deep']] },
    { match: /\bquad\b/i,                 db: '140 dB',      isNew: false, audio: AUDIO.quad,
      specs: [['Loudness', '140 dB'], ['Audible to', '~1/2 mile'], ['Tone', 'Mid']] },
    { match: /(5-?trumpet|quintuple)/i,   db: '130 dB',      isNew: false, audio: AUDIO.dual,
      specs: [['Loudness', '130 dB'], ['Audible to', '~1/4 mile'], ['Tone', 'Deep']] },
    { match: /\bdual\b/i,                 db: '130 dB',      isNew: false, audio: AUDIO.dual,
      specs: [['Loudness', '130 dB'], ['Audible to', '~1/4 mile'], ['Tone', 'Mid']] },
    { match: /\bdiy\b/i,                  db: 'up to 150 dB', isNew: false, audio: AUDIO.quad,
      specs: [['Loudness', 'up to 150 dB'], ['Audible to', 'up to 1 mile'], ['Tone', 'Custom build']] }
  ];

  function pickTier(title) {
    for (var i = 0; i < TIERS.length; i++) if (TIERS[i].match.test(title)) return TIERS[i];
    return null;
  }
  function readMoney(node) {
    if (!node) return 0;
    var s = (node.textContent || '').replace(/[^\d.,]/g, '').replace(/,/g, '');
    var n = parseFloat(s);
    return isFinite(n) ? n : 0;
  }

  var STAR_ON  = '<svg class="thd-star thd-star--on"  viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M8 1l2.09 4.6 5.06.46-3.81 3.35 1.13 4.97L8 11.85 3.53 14.38l1.13-4.97L.85 6.06l5.06-.46L8 1z"/></svg>';
  var STAR_OFF = '<svg class="thd-star thd-star--off" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M8 1l2.09 4.6 5.06.46-3.81 3.35 1.13 4.97L8 11.85 3.53 14.38l1.13-4.97L.85 6.06l5.06-.46L8 1z"/></svg>';
  var PLAY_SVG = '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M4 2.5v11l9-5.5-9-5.5z"/></svg>';
  var STOP_SVG = '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><rect x="4" y="4" width="8" height="8" rx="1"/></svg>';

  var currentAudio = null, currentBtn = null;
  function stopCurrent() {
    if (currentAudio) { try { currentAudio.pause(); currentAudio.currentTime = 0; } catch(e){} }
    if (currentBtn) {
      currentBtn.setAttribute('data-playing', 'false');
      var lbl = currentBtn.querySelector('.thd-play-bar__label');
      if (lbl) lbl.textContent = 'Sound';
      var ic = currentBtn.querySelector('.thd-play-bar__icon');
      if (ic) ic.innerHTML = PLAY_SVG;
    }
    currentAudio = null; currentBtn = null;
  }

  function readRating(card) {
    // Try common data attributes / metafield exposures
    var r = card.querySelector('[data-rating-value], [data-judgeme-rating], [data-product-rating]');
    if (r) {
      var v = parseFloat(r.getAttribute('data-rating-value') || r.getAttribute('data-judgeme-rating') || r.getAttribute('data-product-rating') || '');
      var c = parseInt(r.getAttribute('data-rating-count') || r.getAttribute('data-judgeme-count') || r.getAttribute('data-review-count') || '0', 10);
      if (!isNaN(v)) return { value: v, count: isNaN(c) ? 0 : c };
    }
    // Try Judge.me widget elements that may be rendered hidden
    var jdg = card.querySelector('.jdgm-prev-badge[data-average-rating]');
    if (jdg) {
      var v2 = parseFloat(jdg.getAttribute('data-average-rating') || '');
      var c2 = parseInt(jdg.getAttribute('data-number-of-reviews') || '0', 10);
      if (!isNaN(v2) && v2 > 0) return { value: v2, count: isNaN(c2) ? 0 : c2 };
    }
    return null;
  }

  function buildStars(value) {
    var rounded = Math.round(value || 0);
    var html = '';
    for (var i = 0; i < 5; i++) html += (i < rounded) ? STAR_ON : STAR_OFF;
    return html;
  }

  // Horizon hides the .product-grid-view-zoom-out--details overlay in default view
  // and toggles it in zoom-out mode. Our enhancements must anchor to the VISIBLE body,
  // not to nodes inside that overlay (which appear first in DOM order).
  function isInsideZoomOutOverlay(node) {
    return !!(node && node.closest && node.closest('.product-grid-view-zoom-out--details'));
  }
  function queryAllOutsideOverlay(root, selectors) {
    var nodes = root.querySelectorAll(selectors);
    var out = [];
    for (var i = 0; i < nodes.length; i++) if (!isInsideZoomOutOverlay(nodes[i])) out.push(nodes[i]);
    return out;
  }
  function queryFirstOutsideOverlay(root, selectors) {
    var nodes = root.querySelectorAll(selectors);
    for (var i = 0; i < nodes.length; i++) if (!isInsideZoomOutOverlay(nodes[i])) return nodes[i];
    return null;
  }

  function enhance(card) {
    if (card.__thdDone) return;
    card.__thdDone = true;
    try {
      // --- detect title (for tier matching) ---
      // Prefer a visible title; fall back to the title inside the zoom-out overlay,
      // since on this theme the in-overlay <div class="h4"> is often the only title node.
      var titleNode =
        queryFirstOutsideOverlay(card, '.product-card__title, [class*="product-title"], h3, h2, .h3, .h4') ||
        card.querySelector('.product-card__title, [class*="product-title"], h3, h2, .h3, .h4');
      var title = (titleNode && titleNode.textContent || '').trim();
      if (!title) {
        var lnk = card.querySelector('a[href*="/products/"]');
        if (lnk) title = (lnk.getAttribute('aria-label') || lnk.getAttribute('href') || '').replace(/.*\/products\//, '').replace(/-/g, ' ');
      }
      // visible-text fallback
      if (!title || !pickTier(title)) {
        var allText = (card.textContent || '');
        var m = allText.match(/[A-Z][A-Za-z0-9®+ -]+(?:Train Horn|Trumpets|Horn)[^\n]*/);
        if (m) title = m[0];
      }
      var tier = pickTier(title);

      // --- detect price + compute discount (visible body only) ---
      var priceNode =
        queryFirstOutsideOverlay(card, '.price__current, .price-item--regular, [class*="price--final"], [class*="price__final"], .price:not(.compare-at-price)') ||
        card.querySelector('.price__current, .price-item--regular, [class*="price--final"], [class*="price__final"], .price:not(.compare-at-price)');
      var compareNode =
        queryFirstOutsideOverlay(card, '.compare-at-price, [class*="price--compare"], [class*="price__compare"]') ||
        card.querySelector('.compare-at-price, [class*="price--compare"], [class*="price__compare"]');
      var p = readMoney(priceNode), c = readMoney(compareNode);
      var savePct = '';
      if (c > p && c > 0 && p > 0) savePct = Math.round(100 * (c - p) / c) + '% OFF';

      // --- detect VISIBLE price container (anchor for inserting rating/specs/play) ---
      var priceContainer = queryFirstOutsideOverlay(card, '[ref="priceContainer"], .price-container, [class*="price-container"]');
      if (!priceContainer && priceNode) priceContainer = priceNode.closest('div');

      var gallery = card.querySelector('.card-gallery, [class*="card-gallery"]');

      // ----- 1. Badge row (BELOW image, FIRST below the photo) -----
      if (gallery && (savePct || (tier && tier.db) || (tier && tier.isNew))) {
        var badges = document.createElement('div');
        badges.className = 'thd-badge-row';
        if (savePct) { var b1 = document.createElement('span'); b1.className = 'thd-badge thd-badge--sale'; b1.textContent = savePct; badges.appendChild(b1); }
        if (tier && tier.db) { var b2 = document.createElement('span'); b2.className = 'thd-badge thd-badge--db'; b2.textContent = tier.db; badges.appendChild(b2); }
        if (tier && tier.isNew) { var b3 = document.createElement('span'); b3.className = 'thd-badge thd-badge--new'; b3.textContent = 'NEW 2026'; badges.appendChild(b3); }
        // insert right after the gallery (= first thing below the image)
        if (gallery.parentNode) {
          if (gallery.nextSibling) gallery.parentNode.insertBefore(badges, gallery.nextSibling);
          else gallery.parentNode.appendChild(badges);
        }
      }

      // ----- 2. Star rating + review count (AFTER price) -----
      // Only render the rating when there ARE reviews — no "No reviews yet" placeholder.
      if (priceContainer && tier) {
        var ratingData = readRating(card);
        if (ratingData) {
          var ratingEl = document.createElement('div');
          ratingEl.className = 'thd-rating';
          ratingEl.innerHTML =
            '<span class="thd-stars">' + buildStars(ratingData.value) + '</span>' +
            '<span class="thd-rating__value">' + ratingData.value.toFixed(1) + '</span>' +
            '<span class="thd-rating__count">(' + ratingData.count + ' review' + (ratingData.count === 1 ? '' : 's') + ')</span>';
          if (priceContainer.parentNode) priceContainer.parentNode.insertBefore(ratingEl, priceContainer.nextSibling);
        }
      }

      // ----- 3. Spec block (after rating) -----
      if (tier && priceContainer) {
        var specs = document.createElement('div');
        specs.className = 'thd-specs';
        tier.specs.forEach(function (pair) {
          var sp = document.createElement('div');
          sp.className = 'thd-spec';
          var k = document.createElement('span'); k.className = 'thd-spec__k'; k.textContent = pair[0];
          var v = document.createElement('span'); v.className = 'thd-spec__v'; v.textContent = pair[1];
          sp.appendChild(k); sp.appendChild(v);
          specs.appendChild(sp);
        });
        var afterRating = card.querySelector('.thd-rating');
        var target = afterRating || priceContainer;
        if (target && target.parentNode) target.parentNode.insertBefore(specs, target.nextSibling);
      }

      // ----- 4. Listen to sound (after specs) -----
      if (tier && tier.audio) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'thd-play-bar';
        btn.setAttribute('aria-label', 'Play horn sound sample');
        btn.setAttribute('data-playing', 'false');
        var icSpan = document.createElement('span'); icSpan.className = 'thd-play-bar__icon'; icSpan.innerHTML = PLAY_SVG;
        var waveSpan = document.createElement('span'); waveSpan.className = 'thd-play-bar__wave'; waveSpan.setAttribute('aria-hidden', 'true');
        waveSpan.innerHTML = '<i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>';
        var lblSpan = document.createElement('span'); lblSpan.className = 'thd-play-bar__label'; lblSpan.textContent = 'Sound';
        btn.appendChild(icSpan); btn.appendChild(waveSpan); btn.appendChild(lblSpan);
        btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var playing = btn.getAttribute('data-playing') === 'true';
          if (playing) { stopCurrent(); return; }
          stopCurrent();
          var a = new Audio(tier.audio);
          a.preload = 'metadata';
          a.play().then(function () {
            btn.setAttribute('data-playing', 'true');
            lblSpan.textContent = 'Playing…';
            icSpan.innerHTML = STOP_SVG;
            currentAudio = a; currentBtn = btn;
          }).catch(function () {});
          a.addEventListener('ended', function () { stopCurrent(); });
        });
        var specsEl = card.querySelector('.thd-specs');
        var target2 = specsEl || card.querySelector('.thd-rating') || priceContainer;
        if (target2 && target2.parentNode) target2.parentNode.insertBefore(btn, target2.nextSibling);
      }
    } catch (e) {
      if (window.console && console.error) console.error('[thd-card-enhance]', e);
    }
  }

  // Wrap article tables so they scroll horizontally on small screens
  function wrapArticleTables() {
    var root = document.querySelector('[data-template="article"] .blog-post-content');
    if (!root) return;
    var tables = root.querySelectorAll('table');
    for (var i = 0; i < tables.length; i++) {
      var t = tables[i];
      var p = t.parentNode;
      if (p && p.classList && p.classList.contains('lp-table-wrap')) continue;
      var w = document.createElement('div');
      w.className = 'lp-table-wrap';
      p.insertBefore(w, t);
      w.appendChild(t);
    }
  }

  function run() {
    var cards = document.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) enhance(cards[i]);
    wrapArticleTables();
  }
  if (document.readyState !== 'loading') run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  setTimeout(run, 200);
  setTimeout(run, 800);
  setTimeout(run, 2000);

  function startObserver() {
    if (!document.body) { setTimeout(startObserver, 50); return; }
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (!(n && n.nodeType === 1)) continue;
          if (n.tagName === 'PRODUCT-CARD') enhance(n);
          else if (n.querySelector) {
            var inner = n.querySelectorAll('product-card');
            for (var k = 0; k < inner.length; k++) enhance(inner[k]);
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  startObserver();
})();

